import React from 'react';
import "../style/Image.scss";

const Image = ({image, filters, refHook}) => {

    const {blur,brightness,contrast,grayscale,hueRotate,invert,opacity,seturate,sepia} = filters;

    const styles = {
        width: "70%",
        height: "70%",
        filter: `blur(${blur}px) 
        brightness(${brightness}%) 
        contrast(${contrast}%) 
        grayscale(${grayscale}%) 
        hue-rotate(${hueRotate}deg) 
        invert(${invert}%) 
        opacity(${opacity}%) 
        saturate(${seturate}%) 
        sepia(${sepia}%)`,
    }

    return (
        <>
            {
                image && <img 
                    ref={refHook}
                    src={URL.createObjectURL(image)}
                    alt="user data"
                    style={styles}
                />
            }
        </>
    );
};

export default Image;